
/**
 * Copyright (c) 20240701, Mohamed eRrais (merrais / MeR) 
 * from tajwyd.akademy.ma
 * logo.png Compressed from digitalservices.ma
 */

import {arConfig} from './ar';

export const enConfig = {
    ...arConfig.base,
    salaam:'Salaam',

home : {
    ...arConfig.home,
    login:'Login',
    about:'Moshaf Service to read and learn and memorize Al Quraan every time and everywhere',
    article : 'Articles',
    contact : 'Contact',
},

blog:{
    title :'Most Interesting Articles',
    read:'Read more...'
},

profile : {
    ...arConfig.profile,
    salaam:'Salaam',
    profile : 'Profile',
    audio : 'Audio',
    akademy : 'Akademy',
    iqrae : 'Iqrae',
    ihfad:'Memorize',
    all:'Whole',
    search:'Search',
    tadabbor:'Tadabbor',
    tartyl:'Tartyl',
    nass:'Nass',
    monitor:'Monitor',
    aayaat:'Aayaat',
    tilaawa:'Tilaawa',
    akademyApp : 'AkademyApp',
    setting : 'Settings',
    login: 'Login',
    logout : 'Logout',
    admin:'Admin',
    roles: [{Id:1, Value:'Student'},{Id:2, Value:'Teacher'},{Id:3, Value:'Manager'},{Id:4, Value:'Admin'}] 
},

contact:{
    ...arConfig.contact,
    title:'Get In Touch',
    message:'Please fill out the form below to send us an email',
    confirm:'Contact Confirming',
    content:'Please fill out the code we sent you by email to confirm it',
    recipient:"Please confirm the recipient's information.",
    feedback : 'We have received your message, we will get back to you as soon as possible',
    warning : "Need to confirm your email before proceeding"
},

}